// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3lTpn","title":"AfterBackImages_title__2ATxH","images":"AfterBackImages_images__2AOoo"};